import { graphql } from 'react-relay';

import { AppDialogWindowPaginator_query$key } from '../../../relay/__generated__/AppDialogWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const AppDialogWindowPaginator_query = graphql`
  fragment AppDialogWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: AppDialogFilter }
    order: { type: AppDialogOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "AppDialogWindowPaginatorRefreshQuery") {
    appDialogs(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...AppDialogConnectionDataTable_appDialogConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<AppDialogWindowPaginator_query$key>, 'fragment'>;

const AppDialogWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={AppDialogWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.appDialogs.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default AppDialogWindowPaginator;
